import ClientWeightChartModal from './ClientWeightChartModal';

export default ClientWeightChartModal;
